import { Component, ChangeDetectionStrategy } from '@angular/core';
import { INotificationState } from 'src/app/store/states';
import { images } from '../../../images';
import { initialStates } from 'src/app/store/initialisation';
import { LiteralService, NotificationService } from 'src/app/services';
import { NotificationTypes } from 'src/app/models/enums';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotificationsComponent {
  public notification: INotificationState = initialStates.notification;
  public images = images;
  public notificationType = NotificationTypes;

  constructor(
    public notificationService: NotificationService,
    public literalService: LiteralService,
  ) {
    // this.notification = configureStore.getState().notification
  }

  public dismiss() {
    this.notification.show = false;
    // configureStore.dispatch(clearNotificationAction())
  }
}
